import { isEqual, omit } from "lodash";
import { ProviderGroupSubmitValues } from "@/constants/ProviderGroupFormInitialValues";
import { ProviderGroupLocationFormType } from "@/constants/ProviderLocationFromInitialValues";
import { useEditProviderGroupProfile } from "@/queries/admin/provider-group/use-edit-provider-group-profile";
import { useGetProviderGroupProfile } from "@/queries/admin/provider-group/use-get-provider-group-profile";
import { usePgAddLocation } from "@/queries/use-add-location";
import { useChangeProviderGroupAvatar } from "@/queries/use-change-avatar";
import { getStoredRealm, getViewAs } from "@/utils/auth-storage";
import {
  DEFAULT_INS_LABEL_LIST,
  DEFAULT_UUID_NAME_LIST,
  getUnNecessaryTransformData,
  transformMultiSelectFrontEndVal,
  unNecessaryFEOfficeHourTrans,
} from "@/utils/utils";

export const usePracticeSettingProfile = () => {
  const viewAs = getViewAs();
  const realm = getStoredRealm();

  const { mutateAsync: addLocation } = usePgAddLocation();
  const { data: profileData, refetch }: any = useGetProviderGroupProfile(
    realm ?? undefined,
    viewAs !== "provider"
  );
  const { mutateAsync: ChangeProviderGroupAvatar } =
    useChangeProviderGroupAvatar();
  const { mutateAsync: editProviderGroupProfile } =
    useEditProviderGroupProfile();

  function onEditProviderGroupSubmit(values: ProviderGroupSubmitValues) {
    const Transformed = {
      ...profileData,
      officeHours: unNecessaryFEOfficeHourTrans(profileData?.officeHours),
      acceptedInsurances: transformMultiSelectFrontEndVal(
        DEFAULT_INS_LABEL_LIST,
        profileData?.acceptedInsurances as any
      ),
      specialities: transformMultiSelectFrontEndVal(
        DEFAULT_UUID_NAME_LIST,
        profileData?.specialities as any
      ),
    };

    return editProviderGroupProfile({
      providerGroup: {
        ...getUnNecessaryTransformData(
          ["specialities", "acceptedInsurances"],
          values
        ),
      },
    }).then((res) => {
      refetch();
      if (!values?.avatar?.includes(".amazonaws.com")) {
        return ChangeProviderGroupAvatar({
          providerGroupId: values.uuid ?? "",
          avatar: {
            newAvatar: values.avatar,
          },
        }).then((avatarResp) => {
          if (isEqual(omit(values, "avatar"), omit(Transformed, "avatar"))) {
            return avatarResp;
          } else return res;
        });
      }
      return res;
    });
  }

  async function onAddLocationSubmit(values: ProviderGroupLocationFormType) {
    const transFormData: any = getUnNecessaryTransformData(
      ["specialities"],
      values
    );
    return addLocation({
      ...transFormData,
      xTENANTID: realm,
    } as any);
  }

  return { realm, profileData, onEditProviderGroupSubmit, onAddLocationSubmit };
};
